Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var styles = _reactNative.StyleSheet.create({
    heading: {
      textAlign: 'center',
      marginBottom: 0
    },
    locales: {
      width: '100%',
      justifyContent: 'center',
      flexDirection: 'row',
      flexWrap: 'wrap',
      maxWidth: _styles.STYLES.grid.maxTextWidth,
      alignSelf: 'center',
      margin: _reactNative.Platform.OS === 'web' ? "-".concat(spacing.xs) : -spacing.xs
    },
    localeItem: {
      margin: spacing.xs
    },
    activeLocale: {
      textDecorationLine: 'none'
    }
  });
  return {
    styles: styles
  };
};